import { Component } from '@angular/core';
import { NavController,ToastController,ModalController, NavParams, AlertController } from 'ionic-angular';
import * as moment from 'moment';

@Component({
  selector: 'page-checks',
  templateUrl: 'checks.html'
})
export class ChecksPage{
  filter:string;
  user;
  constructor(
    public params: NavParams,
    public modalCtrl: ModalController,
    private alertCtrl : AlertController,
    public toastCtrl: ToastController

  ){
    this.user = this.params.get("user");
   // this.checks = af.list('/checks/'+this.user.$key);
  }

  newCheck() {
    let edit = false;
    let config = {
      title: 'Nueva medición',
      message: "Ingrese los datos solicitados",
      buttons: [
        {
          text: 'Cancelar',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Guardar',
          handler: data => {
            let chk = {
              weight : data.weight,
              fat: data.fat,
              date: data.date,
              health: data.health,
              sport: data.sport,
              hours: data.hours,
              activity : data.activity
            }

            /* this.checks.push(chk).then(_ => {
               let toast = this.toastCtrl.create({
               message: 'Medición agregada exitosamente',
               duration: 3000
               });
               toast.present();
            }); */
          }
        }
      ]
    }
    let inputs = [
      {
        name: 'date',
        placeholder: 'Fecha de Medición',
        type : 'date',
        value : moment().format('YYYY-MM-DD')
      },{
        name: 'weight',
        placeholder: 'Peso en Kg.',
        type: 'number'
      },{
        name: 'fat',
        placeholder: 'Porcentaje de Grasa',
        type: 'number'
      },{
        name: 'sport',
        placeholder : 'Deporte que practica',
        type: 'text'
      },{
        name: 'hours',
        placeholder : 'Horas que practica al día',
        type: 'number'
      },{
        name: 'activity',
        placeholder : 'Actividad deportiva Semanal',
        type: 'number'
      },{
        name: 'health',
        placeholder : 'Estado de Salud',
        type: 'text'
      }
    ];
    config["inputs"] = inputs;
    let prompt = this.alertCtrl.create(config);
    prompt.present();
  }

  remove(i){
   // this.checks.remove(i.$key);
  }

}




// WEBPACK FOOTER //
// ./src/pages/customers/checks/checks.ts